var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAsset10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1910.64789 485.74968",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#28bd30;}.cls-2{fill:#1adc19;}.cls-3{fill:#17aa2d;}.cls-4{fill:#1bc223;}.cls-5{fill:#fefffe;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M714.53176,152.34882h16.43293V332.59965H683.97742V252.48741L645.718,292.54694h-5.13443l-38.0003-40.05953v80.11224H555.596V152.34882h16.94433l70.35476,78.05982Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M823.41867,274.31389v58.28576H776.6871V152.86022H888.63558v41.08914H823.41867v39.2822h57.77095v41.08233Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1005.22074,150.5487c36.20358.2591,73.94818,19.00355,82.67605,63.6793h-45.19056c-7.446-15.40331-19.25585-21.56737-37.48549-21.56737-29.01674,0-44.67916,22.597-44.67916,50.0693,0,29.78383,17.45914,49.29879,44.67916,49.29879,18.48534,0,30.29523-4.87533,38.5117-22.07877h-38.256V230.14953H1090.464c1.02961,17.974,1.02961,35.17738-5.13444,52.63993-12.83951,37.48208-46.98727,51.8626-80.10883,51.8626-45.70536,0-91.92213-30.55434-92.18124-91.92213C913.29861,181.36214,959.51538,150.5487,1005.22074,150.5487Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1235.81361,155.69l30.55775,95.51555h.7671l7.96076-30.55434,22.85268-67.79094h45.70537v6.93456l-62.394,174.605h-26.44951l-28.75763-86.5354h-.7671l-28.761,86.5354h-25.41649l-63.1645-174.605v-6.93456h46.47246l23.10838,67.79094,7.96076,30.55434h.77051L1216.30206,155.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1359.59585,242.989c0-124.27659,184.35906-124.27659,184.35906,0C1543.95491,367.51792,1359.59585,367.51792,1359.59585,242.989Zm137.37179,0c0-64.70892-90.12542-64.70892-90.12542,0C1406.84222,308.20936,1496.96764,308.20936,1496.96764,242.989Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1730.38683,325.92419v6.67546h-51.35461l-30.81-52.89222h-23.8823v52.89222h-45.96106V152.86022h78.82692c70.61046.2591,83.45,85.24667,38.00371,116.06012Zm-73.18108-131.97483c-10.78369-.25911-22.07877,0-32.86586,0v44.928h32.86586C1682.11425,238.8774,1683.39616,194.20165,1657.20575,193.94936Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1826.68653,276.114l-34.40687,56.48564h-48.01348v-6.93456l58.02665-88.32189-51.866-77.54842v-6.93456h46.98727l29.27243,46.735h1.28531l30.03954-46.735h46.21676v6.93456l-51.866,77.54842,58.28576,88.32189v6.93456h-48.27258L1828.22754,276.114Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 477.70677,
    height: 484.6976
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "477.707 485.728 185.616 485.75 264.761 1.031 477.707 1.031 477.707 485.728"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "254.487 0.889 39.083 485.728 218.514 485.728 432.899 1.031 254.487 0.889"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M335.48721,107.68835h24.55318V377.00926h-70.2058V257.30994l-57.16511,59.85475h-7.6716l-56.778-59.85475V377.00926H98.01412V107.68835h25.31729L228.45163,224.32106Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset10);
export default __webpack_public_path__ + "static/media/Asset-10.f5a48d1815dcd6ea19b0c385b47ac4e8.svg";
export { ForwardRef as ReactComponent };